import { DataBox } from './DataBox'

export function BaseDict() {
    return (
        <>
            <DataBox />
        </>
    )
}
